import Dashboard from '@/pages/members/dashboard.vue';
import DashboardTinyEmail from '@/pages/members/dashboard-tinyemail.vue';
import DashboardCheck from '@/pages/members/dashboard-check.vue';
import Login from '@/pages/auth/login.vue';
import Lists from '@/pages/mail_list/index.vue';
import Leads from '@/pages/mail_lead/index.vue';
import ImportLeads from '@/pages/mail_lead/add-multiple-leads.vue';
import ImportedLeadsListing from '@/pages/leads_imports/index.vue';
import Tags from '@/pages/mail_tag/index.vue';
import ListAnalytics from '@/pages/analytics/list.vue';
import ListAnalyticsDetail from '@/components/list-detail.vue';
import BroadcastAnalytics from '@/pages/analytics/broadcast.vue';
import SequenceAnalytics from '@/pages/analytics/sequence.vue';
import LeadAnalytics from '@/pages/analytics/lead.vue';
import Uploadcontacts from '@/pages/contacts/create.vue';
import LeadDetail from '@/pages/mail_lead/show.vue';
import CreateSegement from '@/pages/segments/subscribe.vue';
import EditSegement from '@/pages/segments/subscribe.vue';

import Broadcasts from '@/pages/campaigns/index.vue';
import CreateCampaign from '@/pages/campaigns/create.vue';
import CampaignDetail from '@/pages/campaigns/show.vue';

import Forms from '@/features/studio/LegacyFormsWorkspace.vue';
import FormsHome from '@/features/studio/FormsHome.vue';
import FormDesigner from '@/features/studio/FormDesigner.vue';
import StudioEmailTemplates from '@/features/studio/EmailTemplates.vue';
import PreviewForm from '@/pages/forms/previewform.vue';

import Create from '@/pages/sequences/create.vue';
import CreateForm from '@/pages/forms/create.vue';
import ViewForm from '@/pages/forms/view.vue';
import CustomField from '@/pages/customfields/index.vue';
import AdminSetting from '@/pages/Admin/Setting/index.vue';
import AdminCampaign from '@/pages/Admin/Campaign/index.vue';
import AdminForm from '@/pages/Admin/Form/index.vue';
import Settings from '@/pages/settings/index.vue';
import CreateSender from '@/pages/settings/create.vue';
import AdminSmtp from '@/pages/Admin/Smtp/index.vue';
import CreateAdminSmtp from '@/pages/Admin/Smtp/create.vue';
import AdminSequence from '@/pages/Admin/Sequence/index.vue';
import Blocklists from '@/pages/Admin/BlockLists/index.vue';
import UserSenders from '@/pages/Admin/User_Sender/index.vue';
import UserIpBlock from '@/pages/Admin/IpBlock/index.vue';
import VerificationContent from '@/pages/Admin/VerificationEmail/index.vue';
import GrooveUsers from '@/pages/Admin/GrooveUsers/index.vue';
import SpamAlerts from '@/pages/Admin/SpamAlerts/index.vue';
import UserAlerts from '@/pages/Admin/SpamAlerts/user-alerts.vue';
import SafeList from '@/pages/Admin/Safelists/index.vue';
import BounceMessageSettings from '@/pages/Admin/BounceMessageSettings/index.vue';
import CreateIntegeration from '@/pages/settings/create_integeration.vue';
import TrackingDomains from '@/pages/Admin/TrackingDomains/index.vue';
import Suppressions from '@/pages/suppressions/index.vue';
import GdprWorkbench from '@/pages/gdpr/index.vue';
import Category from '@/pages/mail_category/index.vue';
import ImportUserApprovals from '@/pages/Admin/ImportedLeadsManagement/index.vue';

import AutomationCreate from '@/pages/automations-v2/create.vue';
// import GlobalTemplates from '@/pages/Admin/GlobalTemplates/index.vue'; removing quill email builder
import { legacyLibraryRedirect } from '@/features/studio/template-library';
import EmailTemplateCategories from '@/pages/email-templates-categories/index.vue';
import BroadcastCategories from '@/pages/broadcast-categories/index.vue';
import FormSubmissionConfirmation from '@/pages/forms/form_submission_confirmation.vue';

import BuilderWorkspace from '@/features/builders/BuilderWorkspace.vue';
import LegacyBuilderWorkspace from '@/features/builders/LegacyWorkspace.vue';

export default [
  { path: '/segments', name: 'Segments', redirect: { name: 'GrooveSegmentBuilder' } },
  { path: '/sequences', name: 'Sequences', redirect: { name: 'GrooveSequenceBuilder' } },
  { path: '/automations', name: 'Automations', redirect: { name: 'GrooveAutomations' } },
  { path: '/automations/new/:id?', name: 'GrooveAutomations', component: BuilderWorkspace, props: { feature: 'automations' }, meta: { rule: 'admin' } },
  { path: '/sequences/new/:id?', name: 'GrooveSequenceBuilder', component: BuilderWorkspace, props: { feature: 'sequences' }, meta: { rule: 'admin' } },
  { path: '/segments/new/:id?', name: 'GrooveSegmentBuilder', component: BuilderWorkspace, props: { feature: 'segments' }, meta: { rule: 'admin' } },

  { path: '/forms/new', name: 'StudioForms', component: FormsHome, meta: { rule: 'admin' } },
  { path: '/forms/studio/:id', name: 'StudioFormDesigner', component: FormDesigner, meta: { rule: 'admin' } },
  { path: '/templates/new', name: 'StudioEmailTemplates', component: StudioEmailTemplates, meta: { rule: 'admin' } },
  {
    path: '/',
    name: 'welcome',
    component: DashboardCheck,
    meta: {
      pageTitle: 'frontend_groovemail_dashboard_route_page_title',
      rule: 'guest'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      pageTitle: 'frontend_groovemail_login_route_page_title',
      rule: 'guest'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      pageTitle: 'frontend_groovemail_dashboard_route_page_title',
      rule: 'guest'
    }
  },
  {
    path: '/dashboard-tinyemail',
    name: 'dashboard-tinyemail',
    component: DashboardTinyEmail,
    meta: {
      pageTitle: 'frontend_groovemail_dashboard_route_page_title',
      rule: 'guest'
    }
  },
  {
    path: '/lists',
    name: 'Lists',
    component: Lists,
    meta: {
      pageTitle: 'frontend_groovemail_lists_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/leads-v2',
    name: 'Leads',
    component: Leads,
    meta: {
      pageTitle: 'frontend_groovemail_leads_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/leads',
    name: 'Leads2',
    component: Leads,
    meta: {
      pageTitle: 'frontend_groovemail_leads_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/import-leads',
    name: 'ImportLeads',
    component: ImportLeads,
    meta: {
      pageTitle: 'frontend_groovemail_import_leads_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/imported-leads',
    name: 'ImportedLeadsListing',
    component: ImportedLeadsListing,
    meta: {
      pageTitle: 'frontend_groovemail_imported_leads_listing_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/tags',
    name: 'Tags',
    component: Tags,
    meta: {
      pageTitle: 'frontend_groovemail_tags_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/list',
    name: 'ListAnalytics',
    component: ListAnalytics,
    meta: {
      pageTitle: 'frontend_groovemail_list_analytics_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/detail/:id',
    name: 'ListAnalyticsDetail',
    component: ListAnalyticsDetail,
    meta: {
      pageTitle: 'frontend_groovemail_analytics_details_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/broadcast',
    name: 'BroadcastAnalytics',
    component: BroadcastAnalytics,
    meta: {
      pageTitle: 'frontend_groovemail_broadcasts_analytics_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/sequence',
    name: 'SequenceAnalytics',
    component: SequenceAnalytics,
    meta: {
      pageTitle: 'frontend_groovemail_sequence_analytics_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/lead',
    name: 'LeadAnalytics',
    component: LeadAnalytics,
    meta: {
      pageTitle: 'frontend_groovemail_lead_analytics_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/import/:id',
    name: 'Uploadcontacts',
    component: Uploadcontacts,
    meta: {
      pageTitle: 'frontend_groovemail_import_contacts_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/leads/:id',
    name: 'LeadDetail',
    component: LeadDetail,
    meta: {
      pageTitle: 'frontend_groovemail_lead_detail_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/leads/:id',
    name: 'analyticsLeadDetail',
    component: LeadDetail,
    meta: {
      pageTitle: 'frontend_groovemail_lead_detail_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/create/:id',
    name: 'CreateSegement',
    component: CreateSegement,
    meta: {
      pageTitle: 'frontend_groovemail_create_segment_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/edit/:id',
    name: 'EditSegement',
    component: EditSegement,
    meta: {
      pageTitle: 'frontend_groovemail_update_segment_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/segments/legacy',
    name: 'SegmentsLegacy',
    component: LegacyBuilderWorkspace,
    props: { feature: 'segments' },
    meta: {
      pageTitle: 'frontend_groovemail_segment_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/broadcast',
    name: 'Broadcasts',
    component: Broadcasts,
    meta: {
      pageTitle: 'frontend_groovemail_broadcasts_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/campaign/create',
    name: 'NewCampaign',
    component: CreateCampaign,
    meta: {
      pageTitle: 'frontend_groovemail_create_campaign_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/campaign/create/:id',
    name: 'EditCampaign',
    component: CreateCampaign,
    meta: {
      pageTitle: 'frontend_groovemail_edit_campaign_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/campaign/:id',
    name: 'CampaignDetail',
    component: CampaignDetail,
    meta: {
      pageTitle: 'frontend_groovemail_campaign_detail_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/automations/legacy',
    name: 'AutomationsLegacy',
    component: LegacyBuilderWorkspace,
    props: { feature: 'automations' },
    meta: {
      pageTitle: 'frontend_groovemail_automations_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/forms',
    name: 'Forms',
    component: Forms,
    meta: {
      pageTitle: 'frontend_groovemail_forms_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/sequences/legacy',
    name: 'SequencesLegacy',
    component: LegacyBuilderWorkspace,
    props: { feature: 'sequences' },
    meta: {
      pageTitle: 'frontend_groovemail_sequences_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/sequence/:id',
    name: 'Sequencestep',
    component: Create,
    meta: {
      pageTitle: 'frontend_groovemail_sequences_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/form/create/:id',
    name: 'NewForm',
    component: CreateForm,
    meta: {
      pageTitle: 'frontend_groovemail_create_form_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/form/edit/:id',
    name: 'EditForm',
    component: CreateForm,
    meta: {
      pageTitle: 'frontend_groovemail_edit_form_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/embedForm/view/:permalink',
    name: 'ViewForm',
    component: ViewForm,
    meta: {
      pageTitle: 'frontend_groovemail_edit_form_route_page_title',
      rule: 'admin'
    }
  }, 
  {
    path: '/form/preview/:id',
    name: 'PreviewForm',
    component: PreviewForm,
    meta: {
      pageTitle: 'frontend_groovemail_preview_form_route_page_title',
      rule: 'admin'
    }
  },
 
  {
    path: '/custom-fields',
    name: 'CustomField',
    component: CustomField,
    meta: {
      pageTitle: 'frontend_groovemail_custom_fields_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/setting',
    name: 'AdminSetting',
    component: AdminSetting,
    meta: {
      pageTitle: 'frontend_groovemail_admin_settings_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/campaign',
    name: 'AdminCampaign',
    component: AdminCampaign,
    meta: {
      pageTitle: 'frontend_groovemail_admin_campaigns_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/form',
    name: 'AdminForm',
    component: AdminForm,
    meta: {
      pageTitle: 'frontend_groovemail_admin_forms_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      pageTitle: 'frontend_groovemail_senders_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/senders/create',
    name: 'NewSender',
    component: CreateSender,
    meta: {
      pageTitle: 'frontend_groovemail_create_sender_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/senders/edit/:id',
    name: 'EditSender',
    component: CreateSender,
    meta: {
      pageTitle: 'frontend_groovemail_edit_sender_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/smtp',
    name: 'AdminSmtp',
    component: AdminSmtp,
    meta: {
      pageTitle: 'frontend_groovemail_admin_smtp_setting_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/smtp/create',
    name: 'NewAdminSmtp',
    component: CreateAdminSmtp,
    meta: {
      pageTitle: 'frontend_groovemail_create_smtp_setting_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/smtp/edit/:id',
    name: 'EditAdminSmtp',
    component: CreateAdminSmtp,
    meta: {
      pageTitle: 'frontend_groovemail_edit_smtp_setting_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/sequence/emails',
    name: 'AdminSequence',
    component: AdminSequence,
    meta: {
      pageTitle: 'frontend_groovemail_admin_sequences_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/blocklists',
    name: 'Blocklists',
    component: Blocklists,
    meta: {
      pageTitle: 'frontend_groovemail_blocklists_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/user-senders',
    name: 'UserSenders',
    component: UserSenders,
    meta: {
      pageTitle: 'frontend_groovemail_user_senders_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/user-ip-block',
    name: 'UserIpBlock',
    component: UserIpBlock,
    meta: {
      pageTitle: 'frontend_groovemail_blocked_user_ips_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/verification-email-content',
    name: 'VerificationContent',
    component: VerificationContent,
    meta: {
      pageTitle:
        'frontend_groovemail_verification_email_settings_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/groove-users',
    name: 'GrooveUsers',
    component: GrooveUsers,
    meta: {
      pageTitle: 'frontend_groovemail_groove_users_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/safelists',
    name: 'SafeList',
    component: SafeList,
    meta: {
      pageTitle: 'frontend_groovemail_safelists_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/integerations/create',
    name: 'CreateIntegeration',
    component: CreateIntegeration,
    meta: {
      pageTitle: 'frontend_groovemail_create_sender_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/integerations/edit/:id',
    name: 'EditIntegeration',
    component: CreateIntegeration,
    meta: {
      pageTitle: 'frontend_groovemail_edit_sender_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/tracking-domains',
    name: 'TrackingDomains',
    component: TrackingDomains,
    meta: {
      pageTitle: 'frontend_groovemail_tracking_domains_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/privacy',
    name: 'PrivacyAndDataRequests',
    component: GdprWorkbench,
    meta: {
      pageTitle: 'Privacy and Data Requests',
      rule: 'admin'
    }
  },
  {
    path: '/suppressions',
    name: 'Suppressions',
    component: Suppressions,
    meta: {
      pageTitle: 'frontend_groovemail_suppressions_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/category',
    name: 'Category',
    component: Category,
    meta: {
      pageTitle: 'frontend_sites_template_categories',
      rule: 'admin'
    }
  },
  {
    path: '/admin/imported-user-approvals',
    name: 'ImportUserApprovals',
    component: ImportUserApprovals,
    meta: {
      pageTitle: 'frontend_groovemail_admin_import_user_approvals',
      rule: 'admin'
    }
  },
  // removing quill email builder
  // {
  //   path: '/admin/global-templates',
  //   name: 'GlobalTemplates',
  //   component: GlobalTemplates,
  //   meta: {
  //     pageTitle: 'frontend_groovemail_admin_global_templates_page_header',
  //     rule: 'admin'
  //   }
  // },
  // removing quill email builder
  {
    path: '/my-templates',
    name: 'MyTemplates',
    redirect: legacyLibraryRedirect,
    meta: {
      pageTitle: 'frontend_groovemail_modal_email_template_header',
      rule: 'admin'
    }
  },
  {
    path: '/email-template-categories',
    name: 'EmailTemplateCategories',
    component: EmailTemplateCategories,
    meta: {
      pageTitle: 'frontend_sites_template_categories',
      rule: 'admin'
    }
  },
  {
    path: '/broadcast-categories',
    name: 'BroadcastCategories',
    component: BroadcastCategories,
    meta: {
      pageTitle: 'frontend_sites_template_categories',
      rule: 'admin'
    }
  },
  {
    path: '/automations-v2',
    name: 'AutomationV2',
    component: LegacyBuilderWorkspace,
    props: { feature: 'automations', visual: true },
    meta: {
      pageTitle: 'frontend_groovemail_automations_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/automation/create',
    name: 'AutomationCreate',
    component: AutomationCreate,
    meta: {
      pageTitle: 'frontend_groovemail_automations_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/automation/edit/:id',
    name: 'AutomationEdit',
    component: AutomationCreate,
    meta: {
      pageTitle: 'frontend_groovemail_automations_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/form-submission-confirmation',
    name: 'FormSubmissionConfirmation',
    component: FormSubmissionConfirmation,
    meta: {
      pageTitle: 'frontend_groovemail_form_submission_success_page',
      rule: 'admin'
    }
  },
  {
    path: '/admin/spamalerts',
    name: 'SpamAlerts',
    component: SpamAlerts,
    meta: {
      pageTitle: 'frontend_groovemail_admin_spamalert_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/useralerts/:id',
    name: 'UserAlerts',
    component: UserAlerts,
    meta: {
      pageTitle: 'frontend_groovemail_admin_user_alert_history_route_page_title',
      rule: 'admin'
    }
  },
  {
    path: '/admin/bounce-message-settings',
    name: 'BounceMessageSettings',
    component: BounceMessageSettings,
    meta: {
      pageTitle: 'frontend_groovemail_admin_bounce_message_settings_route_page_title',
      rule: 'admin'
    }
  },
];
